<svg 
    aria-hidden="true" 
    focusable="false" 
    data-prefix="fas" 
    :icon="getIcon" 
    role="img" 
    xmlns="http://www.w3.org/2000/svg" 
    :viewBox="getIconViewBox" 
    :class="getClass">
    <path data-v-2888da72="" fill="currentColor" :d="getIconPath" class="">

    </path>
</svg>